[
    "albumine",
    "albumine",
    "aldioxa",
    "allantoïne",
    "acides alphahydroxyacides",
    "acides alpha-hydroxy",
    "acides alpha-hydroxy",
    "acides aminés",
    "acides aminés",
    "acide aminosuccinate",
    "protéine hydrolysée d'ammonium",
    "acide aspartique",
    "aspic",
    "bêta carotène",
    "biotine",
    "acide benzoïque",
    "soie",
    "carbonate de calcium",
    "hydroxyde de calcium",
    "lactate de calcium",
    "oxyde de calcium",
    "phosphate de calcium",
    "stéarate de calcium",
    "bétaïne caprylique",
    "oxyde de caprylamine",
    "acide caprylique",
    "noir de carbone",
    "alcool cétylique",
    "éther cétylique",
    "palmitate de cétyle",
    "alcool cétylique",
    "palmitate de cétyle",
    "craie",
    "charbon",
    "chitine",
    "cholécalciférol",
    "chymosine",
    "couleur",
    "couleurs",
    "civette",
    "corticostéroïde",
    "corticostéroïde",
    "cortisone",
    "cortisone corticostéroïde",
    "dexpanthénol",
    "diglycérides",
    "disodiuminosinate",
    "colorant",
    "colorants",
    "e129",
    "e133",
    "e170",
    "e322",
    "e470",
    "e570",
    "e585",
    "e631",
    "e640",
    "e901",
    "e910",
    "e920",
    "enzymes",
    "ergocalciférol",
    "estradiol",
    "graisses",
    "couleurs fd et c",
    "couleurs fd&c",
    "feutre",
    "gluconolactone",
    "glucosamine",
    "acide glutamique",
    "glycérides",
    "glycérol",
    "glycine",
    "glycogène",
    "hydrocortisone",
    "inositol",
    "insuline",
    "myristate d'isopropyle",
    "acide l-lactique",
    "acide lactique",
    "lécithine",
    "leucine",
    "acide linoléique",
    "lipides",
    "lipoïdes",
    "lysine",
    "mono et di-glycérides",
    "mono-diglycérides",
    "monoglycérides",
    "monoglycérides glycérides",
    "glutamate monosodique",
    "msg",
    "musc",
    "huile de musc",
    "sulfate d'éther myristal",
    "acide myristique",
    "arôme naturel",
    "arômes naturels",
    "sources naturelles",
    "acides nucléiques",
    "acides nucléiques",
    "dodécanol octylique",
    "œstrogène",
    "huiles",
    "acide oléique",
    "acide oléique",
    "alcool oléique",
    "huile oléique",
    "oleth",
    "myristate d'oléyle",
    "palmitamide",
    "palmitamine",
    "palmitate",
    "acide palmitique",
    "panthénol",
    "panthényle",
    "polysorbates",
    "polypeptides",
    "lactate de potassium",
    "progestérone",
    "propylèneglycol",
    "provitamine a",
    "provitamine b-5",
    "provitamine d-2",
    "jaune quinoléine",
    "rouge 40",
    "présure",
    "rennine",
    "acide ribonucléique",
    "arn",
    "hydrolysat de saccharide",
    "cire d'abeille sorbitan",
    "monoléate de sorbitan",
    "monostéarate de sorbitan",
    "trioléate de sorbitan",
    "tristéarate de sorbitan",
    "éponge",
    "squalane",
    "squalène",
    "stéaramide",
    "stéaramine",
    "oxyde de stéaramine",
    "stéarate",
    "stéarates",
    "acide stéarique",
    "hydrazide stéarique",
    "acide stéarique",
    "stéarine",
    "stéarone",
    "stéaroxytriméthylsilane",
    "acide lactylique stéaroyle",
    "acétate de stéaryle",
    "alcool stéarylique",
    "alcool stéarylique stérols",
    "bétaïne stéarylique",
    "caprylate de stéaryle",
    "citrate de stéaryle",
    "glycyrrhétinate de stéaryle",
    "heptanoate de stéaryle",
    "imidazoline stéarylique",
    "octanoate de stéaryle",
    "stéarate de stéaryle",
    "tartrate de stéaryle",
    "tartrate de stéaryle",
    "stéroïde",
    "stérol",
    "daim",
    "suif",
    "jaune sunset fcf",
    "tartrazine",
    "taurine",
    "testostérone",
    "thréonine",
    "vélin",
    "velours",
    "vitamine a",
    "vitamine b",
    "facteur complexe vitamine b",
    "vitamine b1",
    "vitamine b12",
    "vitamine d3",
    "vitamine h",
    "jaune5",
    "jaune6"
]